import React, { useState, useEffect } from "react";

import { InputGroup } from "react-bootstrap";
import { Button } from "react-bootstrap";

import { format } from "date-fns";
import * as XLSX from "xlsx";

import AgGridReactEx from "@app/components/AgGridReactEx";

import utility from "@app/lib/utility";

const CardStatBooks = ({ id, title, total = 0, titleBgClass = "" }) => {
    useEffect(() => {
        return () => {};
    }, [title, total]);

    return (
        <div className={`card mb-1 h-100`} style={{}}>
            <div className={`card-header stat-content ${titleBgClass}`}>
                {title}
            </div>
            <div className="card-body text-dark">
                <div className="row">
                    <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                        {(total ? total : 0).toLocaleString()}
                    </div>
                </div>
            </div>
        </div>
    );
};

const NurseryList = ({list, hideBranch = false, onSelectNursery, visible = true}) => {
    const [tableData, setTableData] = useState(null);
    const [searchParam, setSearchParam] = useState({
        type: "",
        value: "",
    });

    useEffect(() => {
        if(list) {
            applyData(searchParam, list);
        }
        return () => {};
    }, [list]);

    const defaultColDef = {
        editable: false,
        sortable: true,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
        suppressMovable: true,
    };
    const listColumn = [
        {
            headerName: "No",
            field: "no",
            width: 50,
            valueGetter: "node.rowIndex + 1",
        },
        {
            headerName: "지사",
            field: "branchName",
            width: 100,
            hide: hideBranch
        },
        {
            headerName: "원명",
            field: "nursery",
            width: 100,
        },
        {
            headerName: "앱 사용자 수",
            field: "install",
            width: 130,
            cellRenderer: (params) => {
                return params.value ? params.value.toLocaleString() : '0';
            },
        },
        {
            headerName: "연간 앱 실행 수",
            field: "access",
            width: 140,
            cellRenderer: (params) => {
                return params.value ? params.value.toLocaleString() : '0';
            },
        },
        {
            headerName: "최근 한달 앱 실행 수",
            field: "accessMonthTotal",
            width: 140,
            cellRenderer: (params) => {
                return params.value ? params.value.toLocaleString() : '0';
            },
        },
        {
            headerName: "연간 콘텐츠 이용 수",
            field: "play",
            width: 140,
            cellRenderer: (params) => {
                return params.value ? params.value.toLocaleString() : '0';
            },
        },
        {
            headerName: "최근 한달 콘텐츠 이용 수",
            field: "playMonthTotal",
            width: 140,
            cellRenderer: (params) => {
                return params.value ? params.value.toLocaleString() : '0';
            },
        },
    ];
    const onRowClicked = (e) => {
        if (onSelectNursery && e && e.data) {
            onSelectNursery(e.data.branch_id, e.data.id, e.data.nursery);
        }
    };
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };
    const onSearch = () => {
        applyData(searchParam, list);
    };

    const applyData = (searchParam, list) => {
        var tableData = listSearch(searchParam, list);

        setTableData(tableData);
        setSearchParam(searchParam);
        // if (gridApi) {
        //     gridApi.setSortModel([{ colId: "accessMonthTotal", sort: "desc" }]);
        // }
    };

    const searchField = ["nursery"];
    const listSearch = (searchParam, list) => {
        let tableDataNew = [];
        if(!list) {
            list = [];
        }
        if (!searchParam.type && !searchParam.value) {
            tableDataNew = list;
        } else {
            list.forEach((item) => {
                searchField.forEach((field) => {
                    if (searchParam.type && item.status !== searchParam.type) {
                        return;
                    }
                    if (!searchParam.value || (item[field] && item[field].indexOf(searchParam.value) >= 0)) {
                        if (tableDataNew.findIndex((d) => d.id == item.id) == -1) {
                            tableDataNew.push(item);
                        }
                    }
                });
            });
        }
        return tableDataNew;
    };

    let gridApi = null;
    const onGridReady = (params) => {
        gridApi = params.api;
        gridApi.setSortModel([{ colId: "accessMonthTotal", sort: "desc" }]);
    };

    const nurseryPage = (branchId) => {
        window.location.href = "../../tas/manage/nursery?branch_id=" + branchId;
    };

    const detailPage = (branchId) => {
        window.location.href = "?type=view&id=" + branchId;
    };
    const saveContractTableXlsx = () => {
        if (!tableData || tableData.length === 0) {
            alert("통계 목록이 없습니다.");
            return false;
        }

        const excelHandler = {
            getExcelData() {
                const excelData = {
                    fileName: `별별책방(부모)` + "_" + format(new Date(), "yyyyMMddHHmmss") + ".xlsx",
                    sheets: [
                        {
                            name: "별별책방(부모)",
                            columnTitle: ["no", "지사", "원명", "앱 사용자 수", "연간 앱실행 수", "최근 한달 앱 실행 수", "연간 콘텐츠 이용 수", "최근 한달 콘텐츠 이용 수"],
                            data: tableData ? tableData.map((s, idx) => [idx + 1, s.branchName, s.nursery, s.install, s.access, s.accessMonthAvg, s.play, s.playMonthAvg]) : [],
                        },
                    ],
                };
                return excelData;
            },
        };
        var wb = XLSX.utils.book_new();
        var excelData = excelHandler.getExcelData();
        excelData.sheets.forEach((s) => {
            var ws = XLSX.utils.aoa_to_sheet([]);
            XLSX.utils.sheet_add_aoa(ws, [excelData.sheets[0].columnTitle], { origin: { r: 0, c: 0 } });
            XLSX.utils.sheet_add_json(ws, s.data, { origin: { r: 1, c: 0 }, skipHeader: true });

            XLSX.utils.book_append_sheet(wb, ws, s.name);
        });

        var wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
        utility.download2Excel(wbout, excelData.fileName);
    };

    return visible ? (
        <div>
            <div className="row align-items-end">
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 pl-4">
                    <h5 className="mb-0" style={{ alignSelf: "end" }}>
                        <span>
                            {tableData && tableData.length > 0 ? tableData.length.toLocaleString() : "0"} / {list && list.length > 0 ? list.length.toLocaleString() : "0"}
                        </span>
                    </h5>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"></div>
                <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 pb-2">
                    <InputGroup className="input-group my-group">
                        <input
                            className="form-control"
                            type="text"
                            value={searchParam.value}
                            placeholder="원 검색"
                            onChange={(e) => {
                                const param = { ...searchParam };
                                param.value = e.target.value;
                                setSearchParam(param);
                            }}
                            onKeyPress={handleKeyPress}
                        />
                        <InputGroup.Append>
                            <Button className="btn btn-primary" onClick={onSearch}>
                                검색
                            </Button>
                        </InputGroup.Append>
                    </InputGroup>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <AgGridReactEx
                        defaultColDef={defaultColDef}
                        columnDefs={listColumn}
                        rowData={tableData}
                        onRowClicked={onRowClicked}
                        height={550}
                        pagination={true}
                        excelDownload={true}
                        excelDataHandler={saveContractTableXlsx}
                        onGridReady={onGridReady}
                    />
                </div>
            </div>
        </div>
    ) : (<></>);
};

const ClassList = ({list}) => {
    const [tableData, setTableData] = useState(null);
    const [searchParam, setSearchParam] = useState({
        type: "",
        value: "",
    });

    useEffect(() => {
        if(list) {
            applyData(searchParam, list);
        }
        return () => {};
    }, [list]);

    const defaultColDef = {
        editable: false,
        sortable: true,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
        suppressMovable: true,
    };
    const listColumn = [
        {
            headerName: "No",
            field: "no",
            width: 50,
            valueGetter: "node.rowIndex + 1",
        },
        {
            headerName: "반명",
            field: "className",
            width: 100,
        },
        {
            headerName: "계정",
            field: "userId",
            width: 100,
        },
        {
            headerName: "앱 사용자 수",
            field: "install",
            width: 130,
            cellRenderer: (params) => {
                return params.value ? params.value.toLocaleString() : '0';
            },
        },
        {
            headerName: "연간 앱 실행 수",
            field: "access",
            width: 140,
            cellRenderer: (params) => {
                return params.value ? params.value.toLocaleString() : '0';
            },
        },
        {
            headerName: "최근 한달 앱 실행 수",
            field: "accessMonthTotal",
            width: 140,
            cellRenderer: (params) => {
                return params.value ? params.value.toLocaleString() : '0';
            },
        },
        {
            headerName: "연간 콘텐츠 이용 수",
            field: "play",
            width: 140,
            cellRenderer: (params) => {
                return params.value ? params.value.toLocaleString() : '0';
            },
        },
        {
            headerName: "최근 한달 콘텐츠 이용 수",
            field: "playMonthTotal",
            width: 140,
            cellRenderer: (params) => {
                return params.value ? params.value.toLocaleString() : '0';
            },
        },
    ];
    const onRowClicked = (params) => {
        // const historyState = {
        //     searchParam: { type: searchParam.type, value: searchParam.value },
        // };
        // history.replace(location.pathname, historyState);
        // if (params.api.getFocusedCell().column.getColId() === "nursery") {
        //     nurseryPage(params.data.id);
        // } else {
        //     detailPage(params.data.id);
        // }
    };
    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch();
        }
    };
    const onSearch = () => {
        applyData(searchParam, list);
    };

    const applyData = (searchParam, list) => {
        var tableData = listSearch(searchParam, list);

        setTableData(tableData);
        setSearchParam(searchParam);
        // if (gridApi) {
        //     gridApi.setSortModel([{ colId: "accessMonthTotal", sort: "desc" }]);
        //     console.debug('sort gogo');
        // }
    };

    const searchField = ["nursery"];
    const listSearch = (searchParam, list) => {
        let tableDataNew = [];
        if(!list) {
            list = [];
        }
        if (!searchParam.type && !searchParam.value) {
            tableDataNew = list;
        } else {
            list.forEach((item) => {
                searchField.forEach((field) => {
                    if (searchParam.type && item.status !== searchParam.type) {
                        return;
                    }
                    if (!searchParam.value || (item[field] && item[field].indexOf(searchParam.value) >= 0)) {
                        if (tableDataNew.findIndex((d) => d.id == item.id) == -1) {
                            tableDataNew.push(item);
                        }
                    }
                });
            });
        }
        return tableDataNew;
    };

    let gridApi = null;
    const onGridReady = (params) => {
        gridApi = params.api;
        gridApi.setSortModel([{ colId: "accessMonthTotal", sort: "desc" }]);
    };

    const nurseryPage = (branchId) => {
        window.location.href = "../../tas/manage/nursery?branch_id=" + branchId;
    };

    const detailPage = (branchId) => {
        window.location.href = "?type=view&id=" + branchId;
    };
    const saveContractTableXlsx = () => {
        if (!tableData || tableData.length === 0) {
            alert("통계 목록이 없습니다.");
            return false;
        }

        const excelHandler = {
            getExcelData() {
                const excelData = {
                    fileName: `별별책방(부모)` + "_" + format(new Date(), "yyyyMMddHHmmss") + ".xlsx",
                    sheets: [
                        {
                            name: "별별책방(부모)",
                            columnTitle: ["no", "반명", "계정", "앱 사용자 수", "연간 앱실행 수", "최근 한달 앱 실행 수", "연간 콘텐츠 이용 수", "최근 한달 콘텐츠 이용 수"],
                            data: tableData ? tableData.map((s, idx) => [idx + 1, s.className, s.userId, s.install, s.access, s.accessMonthAvg, s.play, s.playMonthAvg]) : [],
                        },
                    ],
                };
                return excelData;
            },
        };
        var wb = XLSX.utils.book_new();
        var excelData = excelHandler.getExcelData();
        excelData.sheets.forEach((s) => {
            var ws = XLSX.utils.aoa_to_sheet([]);
            XLSX.utils.sheet_add_aoa(ws, [excelData.sheets[0].columnTitle], { origin: { r: 0, c: 0 } });
            XLSX.utils.sheet_add_json(ws, s.data, { origin: { r: 1, c: 0 }, skipHeader: true });

            XLSX.utils.book_append_sheet(wb, ws, s.name);
        });

        var wbout = XLSX.write(wb, { bookType: "xlsx", type: "binary" });
        utility.download2Excel(wbout, excelData.fileName);
    };

    return (
        <div>
            <div className="row align-items-end">
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 pl-4">
                    <h5 className="mb-0" style={{ alignSelf: "end" }}>
                        <span>
                            {tableData && tableData.length > 0 ? tableData.length.toLocaleString() : "0"} / {list && list.length > 0 ? list.length.toLocaleString() : "0"}
                        </span>
                    </h5>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12"></div>
                <div className="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 pb-2">
                    <InputGroup className="input-group my-group">
                        <input
                            className="form-control"
                            type="text"
                            value={searchParam.value}
                            placeholder="원 검색"
                            onChange={(e) => {
                                const param = { ...searchParam };
                                param.value = e.target.value;
                                setSearchParam(param);
                            }}
                            onKeyPress={handleKeyPress}
                        />
                        <InputGroup.Append>
                            <Button className="btn btn-primary" onClick={onSearch}>
                                검색
                            </Button>
                        </InputGroup.Append>
                    </InputGroup>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <AgGridReactEx
                        defaultColDef={defaultColDef}
                        columnDefs={listColumn}
                        rowData={tableData}
                        onRowClicked={onRowClicked}
                        height={550}
                        pagination={true}
                        excelDownload={true}
                        excelDataHandler={saveContractTableXlsx}
                        onGridReady={onGridReady}
                    />
                </div>
            </div>
        </div>
    );
};

export { CardStatBooks, NurseryList, ClassList };
